import React, { useState } from 'react';
import prayerImage from '../assets/pope 2.jpg';  // Image of people praying in a church
import meditationImage from '../assets/pope1.jpg';  // Image of peaceful meditation/prayer room
import communityImage from '../assets/pope3.jpg';  // Image of religious community gathering
import PrayModal from './PrayModal';
import BurnInstructionsCard from './BurnInstructionsCard';

const Hero = () => {
  const [isPrayModalOpen, setIsPrayModalOpen] = useState(false);
  const [addressCopied, setAddressCopied] = useState(false);
  const [showBurnInstructions, setShowBurnInstructions] = useState(false);
  const CONTRACT_ADDRESS = "6TrViD3bU9Tt9q2iThsPxMh7sV6YjECxfXqYodbvpump";
  const BURN_ADDRESS = "1nc1nerator11111111111111111111111111111111";

  const copyAddress = async () => {
    try {
      await navigator.clipboard.writeText(CONTRACT_ADDRESS);
      setAddressCopied(true);
      setTimeout(() => setAddressCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy address:', err);
    }
  };

  return (
    <>
      <section className="min-h-screen relative overflow-hidden bg-gradient-to-br from-gray-900 to-black">
        {/* Background holy glow effect */}
        <div className="absolute inset-0 bg-gradient-radial from-yellow-500/10 via-transparent to-transparent"></div>
        
        <div className="relative container mx-auto px-4 py-20 flex flex-col items-center justify-center min-h-screen">
          {/* Main Content */}
          <div className="text-center max-w-5xl mx-auto space-y-16">
            {/* Header */}
            <div className="space-y-6">
              <h1 className="text-5xl md:text-7xl font-bold animate-gradient bg-gradient-to-r from-yellow-400 via-yellow-200 to-yellow-400 bg-clip-text text-transparent">
                Hope From The Pope
              </h1>
              <p className="text-xl md:text-2xl text-gray-300">
                The Most Blessed Meme Coin in Crypto
              </p>
            </div>

            {/* Contract Address Section */}
            <div className="max-w-xl mx-auto">
              <div className="bg-black/30 backdrop-blur-sm rounded-xl p-4 border border-yellow-400/20">
                <p className="text-sm text-gray-400 mb-2">$HFP Contract Address:</p>
                <div className="flex items-center justify-between bg-black/50 rounded-lg p-3">
                  <code className="text-yellow-400 text-xs sm:text-sm font-mono break-all">
                    {CONTRACT_ADDRESS}
                  </code>
                  <button
                    onClick={copyAddress}
                    className="ml-2 p-2 hover:bg-white/5 rounded-lg transition-colors group"
                    aria-label="Copy contract address"
                  >
                    {addressCopied ? (
                      <span className="text-green-400 text-lg">✓</span>
                    ) : (
                      <span className="text-yellow-400 text-lg group-hover:scale-110 transition-transform inline-block">
                        📋
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
              <button 
                onClick={() => window.open('https://jup.ag/swap/SOL-HFP', '_blank')}
                className="holy-button-primary"
              >
                Buy Now
              </button>
              
              <button 
                onClick={() => setIsPrayModalOpen(true)}
                className="holy-button-secondary group"
              >
                <span className="relative flex items-center justify-center gap-3">
                  <span className="text-2xl group-hover:scale-125 transition-transform duration-300">🙏</span>
                  <span className="uppercase tracking-wider">Say a Prayer</span>
                </span>
              </button>

              <button 
                onClick={() => setShowBurnInstructions(true)}
                className="holy-button-secondary group bg-red-500/20 hover:bg-red-500/30 border-red-500/50"
              >
                <span className="relative flex items-center justify-center gap-3">
                  <span className="text-2xl group-hover:scale-125 transition-transform duration-300">🔥</span>
                  <span className="uppercase tracking-wider">Burn Tokens</span>
                </span>
              </button>
            </div>

            {/* Daily Sermon */}
            <div className="sermon-card space-y-8">
              <div className="flex items-center justify-center gap-4">
                <span className="text-3xl float-animation">✝️</span>
                <h2 className="text-2xl font-bold holy-text">Daily Sermon</h2>
              </div>

              <div className="bg-white/5 rounded-2xl p-6">
                <h3 className="text-xl font-semibold text-yellow-400 mb-4">
                  Today's Blessing
                </h3>
                <p className="text-gray-300 italic mb-4 text-lg">
                  "For God so loved the world, that he gave his only Son, that whoever believes in him should not perish but have eternal life."
                </p>
                <p className="text-yellow-400/80 text-sm">- John 3:16</p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="sermon-card group overflow-hidden">
                  <div className="relative h-48 mb-4 rounded-lg overflow-hidden">
                    <img 
                      src={prayerImage} 
                      alt="Daily Prayer" 
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  </div>
                  <h4 className="text-yellow-400 font-medium mb-2">Daily Prayer</h4>
                  <p className="text-gray-300 text-sm">Join our community in daily prayer for prosperity and guidance</p>
                </div>

                <div className="sermon-card group overflow-hidden">
                  <div className="relative h-48 mb-4 rounded-lg overflow-hidden">
                    <img 
                      src={meditationImage} 
                      alt="Meditation" 
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  </div>
                  <h4 className="text-yellow-400 font-medium mb-2">Meditation</h4>
                  <p className="text-gray-300 text-sm">Take a moment to reflect on your spiritual journey</p>
                </div>

                <div className="sermon-card group overflow-hidden">
                  <div className="relative h-48 mb-4 rounded-lg overflow-hidden">
                    <img 
                      src={communityImage} 
                      alt="Community" 
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  </div>
                  <h4 className="text-yellow-400 font-medium mb-2">Community</h4>
                  <p className="text-gray-300 text-sm">Connect with fellow believers in our blessed community</p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="stat-card">
                <h3 className="text-yellow-400 text-lg font-semibold mb-2">Market Cap</h3>
                <p className="text-3xl font-bold holy-text">$5,223</p>
              </div>

              <div className="stat-card">
                <h3 className="text-yellow-400 text-lg font-semibold mb-2">Holders</h3>
                <p className="text-3xl font-bold holy-text">40</p>
              </div>

              <div className="stat-card">
                <h3 className="text-yellow-400 text-lg font-semibold mb-2">Total Supply</h3>
                <p className="text-3xl font-bold holy-text">1,000,000,000</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Prayer Modal */}
      <PrayModal 
        isOpen={isPrayModalOpen} 
        onClose={() => setIsPrayModalOpen(false)} 
      />

      <BurnInstructionsCard 
        isOpen={showBurnInstructions}
        onClose={() => setShowBurnInstructions(false)}
        burnAddress={BURN_ADDRESS}
      />
    </>
  );
};

export default Hero; 